import React from 'react'
import { BooleanInput } from 'react-admin'
import KToolTip from 'ui-shared/KTooltip'
type Props = {
  defaultBundleSetting?: boolean
  isVisible?: boolean
  source?: string
}
export const BundlePackageToggle: React.FC<Props> = ({
  defaultBundleSetting = true,
  isVisible = false,
  source = '',
}) => {
  if (!isVisible) return null
  return (
    <KToolTip title="tooltip.hint.bundlePackage">
      <BooleanInput
        defaultValue={defaultBundleSetting}
        source={`${source}isBundledPackage`}
        label="resources.drinkPackage.isBundle"
      />
    </KToolTip>
  )
}
